import {
  formatDisplayDate,
  getRangeForPreset,
  toDateInputValue,
  WalletDatePreset,
  WALLET_DATE_PRESET_OPTIONS,
} from '../wallet/walletDateRange'

export type FeedbackDatePreset = WalletDatePreset

export type FeedbackFilterState = {
  preset: FeedbackDatePreset
  date_from: string
  date_to: string
  label: string
  all_time?: boolean
  month?: string
}

export {
  formatDisplayDate,
  getRangeForPreset,
  toDateInputValue,
  WALLET_DATE_PRESET_OPTIONS as FEEDBACK_DATE_PRESET_OPTIONS,
}

export const getDefaultFeedbackFilter = (): FeedbackFilterState => {
  const range = getRangeForPreset('today')
  return {...range}
}

export const buildFeedbackFilterSummary = (
  filter: FeedbackFilterState,
  search: string,
  totalRecords?: number
): string => {
  const rangeText = filter.all_time
    ? 'all dates'
    : filter.date_from === filter.date_to
      ? formatDisplayDate(filter.date_from)
      : `${formatDisplayDate(filter.date_from)} – ${formatDisplayDate(filter.date_to)}`

  const parts = [filter.label, `(${rangeText})`]
  if (search.trim()) parts.push(`search: "${search.trim()}"`)
  if (totalRecords !== undefined) {
    parts.push(`${totalRecords} feedback${totalRecords === 1 ? '' : 's'}`)
  }
  return parts.join(' · ')
}
